<template>
	<div class="mt-2">
		<a
			class="link-secondary"
			href="https://developer.mozilla.org/ru/docs/Web/HTTP/Status"
			target="_blank"
			rel="noopener noreferrer"
			>Полный список статусов</a
		>

		<h2>Коротко</h2>
		<dl>
			<dt>2XX</dt>
			<dd>Скорее всего всё хорошо.</dd>

			<dt>4XX и 5XX</dt>
			<dd>Ошибка, нужно проверить.</dd>

			<dt>1XX и 3XX</dt>
			<dd>Не должны встречаться.</dd>
		</dl>

		<h2>Длинно</h2>
		<dl>
			<dt>200, 204</dt>
			<dd>
				Успешный запрос. Сайт должен отвечать статусом 200, для ресурсов
				возможен ответ 204.
			</dd>

			<dt>301</dt>
			<dd>
				Контент когда-то был по этому адресу, но теперь он переехал.
			</dd>

			<dt>400</dt>
			<dd>Плохой запрос, возможно ошибка в кравлере.</dd>

			<dt>401</dt>
			<dd>Сайт требует авторизоваться.</dd>

			<dt>403</dt>
			<dd>
				Доступ к ресурсу запрещён. Может встретиться в случае, когда
				сайт просит ввести капчу.
			</dd>

			<dt>404</dt>
			<dd>Страница не найдена.</dd>

			<dt>408</dt>
			<dd>Запрос занял слишком много времени.</dd>

			<dt>410</dt>
			<dd>Контент удалён с сервера.</dd>

			<dt>500</dt>
			<dd>Сервер не смог корректно обработать запрос.</dd>

			<dt>503</dt>
			<dd>
				Сервер перегружен или недоступен. Может встретиться в случае,
				когда сайт просит ввести капчу.
			</dd>
		</dl>
	</div>
</template>
